<div class="modal-header">
    <h4 class="modal-title fw-bold">
        <span jhiTranslate="release-notes.title"></span>
    </h4>
</div>
<div class="modal-body">
    <iframe *ngIf="url" [src]="url" width="100%" height="570" frameborder="0"></iframe>
</div>
<div class="modal-footer">
    <div *ngIf="showAgainCheckbox" class="form-check form-check-inline">
        <input type="checkbox" class="form-check-input" name="dontShowAgain" id="dontShowAgain" [(ngModel)]="dontShowAgain">
        <label class="form-check-label" for="dontShowAgain" jhiTranslate="release-notes.dont-show-again-checkbox">
        </label>
    </div>
    <button type="button" class="btn btn-primary" data-bs-dismiss="modal" (click)="dismiss()">
        <span jhiTranslate="ok"></span>
    </button>
</div>

